import { useState, useEffect } from "react";
import Header from "../Components/Header";
import HeroSection from "../Components/HeroSection";
import Footer from "../Components/Footer";
import BackgroundGradient from "../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../Images/BackgroundGradientSmall.png";
import BULB from "../Images/bulb.png";
import { currentSite } from "../Config/siteConfig";

const items = [
  {
    id: 1,
    text: "Quantum-Resistant Cryptographic Systems for Secure Communication",
  },
  { id: 2, text: "Rare-Earth Ion Doped Material-Based Quantum Memory" },
  { id: 3, text: "Input Laser Control Box" },
  {
    id: 4,
    text: "Software-based Quantum Random Number Generation System Using Quantum Simulation And Cloud Backend Execution",
  },
  { id: 5, text: "Quantum Memories " },
  {
    id: 6,
    text: "System and Method for Optimized Quantum Computing with Sequential Gate Teleportation",
  },
  { id: 7, text: "Quantum Memory Box (Design)" },
  {
    id: 8,
    text: "An Intelligent Recommender System for Quantum Computations",
  },
  { id: 9, text: "An Integrated laser controller unit for atomic experiments" },
  { id: 10, text: "Rubidium-based Magnetometer For Bio-Sensing Application" },
  { id: 11, text: "Secure Multi-party Quantum Conference" },
  { id: 12, text: "Secure Quantum Multi-party XOR Computation System" },
  {
    id: 13,
    text: "Long distance measurement-device-independent quantum secure direct communication",
  },
  { id: 14, text: "Simulator for Quantum Computing Systems" },
  { id: 15, text: "Techniques of Quantum Computing Model" },
  { id: 16, text: "Simulator for Quantum Computing Systems (USA)" },
  { id: 17, text: "Quantum Memory Box (USA)" },
  { id: 18, text: "Ultra Long Storage Assisted Quantum Memory (USA)" },
];

const SemiCircleFeatures = () => {
  const radius = 250; // control circle size

  const radius2 = 250;

  return (
    <div className="relative w-full overflow-hidden flex items-center justify-center py-20">
      {/* Bulb */}
      <img src={BULB} alt="bulb" className="w-[220px] md:w-[300px] z-10" />

      {/* LEFT SIDE */}
      <div
        className="absolute inset-0 flex items-center justify-center"
        style={{ top: "50%", left: "46%", transform: "translate(-50%, -50%)" }}
      >
        {items.slice(0, 9).map((item, index) => {
          const angle = 270 - (index + 2) * 15;

          return (
            <div
              key={item.id}
              className="absolute flex items-center gap-2 text-white"
              style={{
                transform: `
                rotate(${angle}deg)
                translate(${radius2}px)
                rotate(-${angle}deg)
              `,
              }}
            >
              <p className="w-[120px] md:w-[180px] text-xs text-right">
                {item.text}
              </p>
              <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs bg-[rgba(70,196,255,0.6)]">
                {item.id}
              </div>
            </div>
          );
        })}
      </div>

      {/* RIGHT SIDE */}
      <div
        className="absolute inset-0 flex items-center justify-center"
        style={{ top: "50%", left: "56%", transform: "translate(-50%, -50%)" }}
      >
        {items.slice(9, 18).map((item, index) => {
          const angle = 270 + (index + 2) * 15;

          return (
            <div
              key={item.id}
              className="absolute flex items-center gap-2 text-white"
              style={{
                transform: `
                rotate(${angle}deg)
                translate(${radius2}px)
                rotate(-${angle}deg)
              `,
              }}
            >
              <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs bg-[rgba(70,196,255,0.6)]">
                {item.id}
              </div>
              <p className="w-[120px] md:w-[180px] text-xs text-left">
                {item.text}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default function Ourips() {
  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    // Set initial background image
    updateBackgroundImage();

    // Update background image on window resize
    window.addEventListener("resize", updateBackgroundImage);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);
  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <Header id={6} />
        <div className="w-full h-[25rem] ">
          <HeroSection
            title1="Innovative. Exclusive."
            title2="Discover our patented products"
            content={`At ${
              currentSite === "site1" ? "Qulabs" : "Quantum AI Global"
            }, Explore our portfolio of patented technologies and proprietary innovations across quantum computing, communication, sensing, and security—reflecting our commitment to deep-tech research and product development. `}
          />
        </div>
        <div className="hidden lg:block relative w-full bg-primary7 width md:px-10  flex-col items-center justify-center">
          <SemiCircleFeatures />

          <div
            className="absolute -z-2 left-1/2 top-[40%] transform -translate-x-1/2 -translate-y-1/2 inset-0 md:w-[80%] md:h-[12rem]"
            style={{
              background:
                "radial-gradient(circle at center, rgba(70,196,255,0.2), transparent )",
              filter: "blur(70px)",
            }}
          ></div>
        </div>

        <div className="lg:hidden relative w-full bg-primary7 flex items-center justify-center px-10 py-12 overflow-hidden">
          {/* RIGHT SIDE BACKGROUND (Bulb + Glow) */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none">
            {/* Glow */}
            <div
              className="absolute w-[60vw] h-[60vw] right-0 top-1/2 -translate-y-1/2"
              style={{
                background:
                  "radial-gradient(circle at center, rgba(70,196,255,0.25), transparent)",
                filter: "blur(80px)",
              }}
            />

            {/* Bulb */}
            <img src={BULB} alt="bulb" className="w-[60vw] max-w-[350px] " />
          </div>

          {/* LEFT SIDE CONTENT */}
          <div className="w-full relative z-10 flex flex-col  gap-3 md:max-w-[60%]">
            {items.map((item) => (
              <div
                key={item.id}
                className="w-full flex  items-center gap-3 text-white"
              >
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs bg-[rgba(70,196,255,0.6)]">
                  {item.id}
                </div>
                <p className="text-xs max-w-[250px] sm:max-w-[400px] ">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer showpage={false} />
    </div>
  );
}
